import type { CreateTruckInput } from '@chukua/common';
import { useState } from 'react';
import { ApiError } from '../../lib/api';
import { useToast } from '../../lib/use-toast';
import { createTruck } from './trucks.api';
import { useTruckList } from './use-truck-list';

/** The trucks list (`useTruckList`) plus create — a form failure stays inline (CLAUDE.md → Web conventions). */
export function useTrucks() {
  const { state, list, isRefreshing, reload } = useTruckList();
  const [createError, setCreateError] = useState<string | null>(null);
  const [creating, setCreating] = useState(false);
  const toast = useToast();

  /** Returns whether it succeeded, so the drawer knows to close itself. */
  async function create(input: CreateTruckInput): Promise<boolean> {
    setCreateError(null);
    setCreating(true);
    try {
      const truck = await createTruck(input);
      await reload();
      toast.success(`${truck.registration} created`);
      return true;
    } catch (err) {
      setCreateError(
        err instanceof ApiError && err.status === 409
          ? 'A truck with this registration already exists.'
          : 'Could not create the truck — check the fields and try again.',
      );
      return false;
    } finally {
      setCreating(false);
    }
  }

  return { state, list, isRefreshing, createError, creating, create, resetCreateError: () => setCreateError(null) };
}
